import { all } from 'redux-saga/effects';

import consultaMunicipioSaga from './consultaMunicipio/saga';

export default all([consultaMunicipioSaga]);
